import { Routes ,Route} from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Project from './pages/Project';
import Pricing from './pages/Pricing';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';


function App() {
  return (
    <>
     <Navbar />
     <Routes>
       <Route path='/' element = {<Home/>} />
       <Route path='/about' element = {<About/>} />
       <Route path='/contact' element = {<Contact/>} />
       <Route path='/projects' element = {<Project/>} />
       <Route path='/pricing' element = {<Pricing/>} />
     </Routes>
     <Footer />
    </>
  );
}

export default App;
